export default {
  at: "@",
  callbacks: {
    matcher: function(flag, subtext, should_start_with_space) {
      var match, regexp;

      flag = flag.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");

      if (should_start_with_space) {
        flag = '(?:^|\\s)' + flag;
      }

      regexp = new RegExp(flag + '([A-Za-z0-9_\\s\+\-\]*)$|' + flag + '([^\\x00-\\xff]*)$', 'gi');
      match = regexp.exec(subtext.replace(/\s/g, " "));
      if (match) {
        return match[2] || match[1];
      } else {
        return null;
      }
    },
    remoteFilter: function(query, callback) {
      window.$.getJSON("/profile/mention_search.json", {search_text: query}, function(data) {
        callback(data.users)
      });
    }
  },
  displayTpl: '<li>${name} <small>${job_title}</small></li>',
  insertTpl: '<a href="/profile/${slug}" data-mention="[user:${id}:${name}]">${atwho-at}${name}</a>',
  limit: 5
}
